import { on } from 'delegated-events';
import showPopup from './modals';
import { slideToggle } from './utils/utils';

export default function () {
    on('change', '[data-target-to-show]', function () {
        let toShow = document.querySelector(`#${this.dataset.targetToShow}`);
        if (!toShow) return;

        slideToggle(toShow);
    });

    // NEWSLETTER POPUP SUBMIT
    on('click', '.goshop-modal .newsletter-clauses-wrapper ~ button[type="submit"]', function (e) {
        const modal = document.querySelector('.basicLightbox');
        const standardNewsletter = modal.classList.contains('standard-newsletter');
        const checkboxes = modal.querySelectorAll('[type="checkbox"]:checked');

        if (checkboxes.length !== 1) {
            modal.querySelector('.newsletter-clauses-wrapper').classList.add('unchecked');
            e.preventDefault();
        } else if (!standardNewsletter && !modal.querySelector('.valid')) {
            const inputField = modal.querySelector('input[type="text"]');

            inputField.dispatchEvent(new Event('focusin', {
                bubbles: true,
                cancelable: true,
                type: 'focusin'
            }));
            inputField.parentElement.classList.add('invalid', 'filled');
        } else {
            window.currentModalInstance.close();

            const recaptchaItem = modal.querySelector('.g-recaptcha-response');

            const input = standardNewsletter
                ? document.querySelector('#newsletter input[type="text"]')
                : modal.querySelector('input[type="text"]');

            const payload = {
                email: input.value,
                recaptcha: recaptchaItem?.value || ''
            };

            fetch('/api/frontend/newsletter', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify(payload)
            }).then(response => response.json())
                .then(data => {
                    input.value = '';
                    showPopup({ body: data.message });
                }).catch(error => {
                    input.value = '';
                    console.log(error);
                });
        }
    });

    // REGULAMIN PROMOCJI ("Rabaty na Komplety") - popup z trescia (koszyk + lista /komplety)
    on('click', '[data-bundle-terms]', function (e) {
        e.preventDefault();
        const holder = document.getElementById(this.getAttribute('data-bundle-terms'));
        if (!holder) return;

        showPopup({
            header: this.getAttribute('data-bundle-terms-title') || 'Regulamin promocji',
            body: holder.innerHTML
        });
    });
}
